export const whatIsProKitRoute: Route = {
  name: 'Prokit คืออะไร',
  pathname: '/',
  hash: 'what-is-pro-kit',
}

export const whyProKitRoute: Route = {
  name: 'ทำไมต้องเรา',
  pathname: '/',
  hash: 'why-pro-kit',
}

export const serviceRoute: Route = {
  name: 'บริการของเรา',
  pathname: '/',
  hash: 'service',
}

export const documentsRoute: Route = {
  name: 'เอกสารทั้งหมด',
  pathname: '/',
  hash: 'documents',
}

export const blogRoute: Route = {
  name: 'Blog',
  pathname: '/',
  hash: 'blog',
}

export const contactRoute: Route = {
  name: 'Contact',
  pathname: '/',
  hash: 'contact',
}

export const releaseNoteRoute: Route = {
  name: 'Release Note',
  pathname: '/release-notes',
  hash: '',
}

const routes: Route[] = [
  whatIsProKitRoute,
  whyProKitRoute,
  serviceRoute,
  documentsRoute,
  releaseNoteRoute,
  blogRoute,
]

export default routes
